import React from 'react';
import styles from './Switch.module.css';

export interface SwitchProps {
  label: string;
  id: string;
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  className?: string;
}

const Switch: React.FC<SwitchProps> = ({
  label,
  id,
  checked = false,
  onChange,
  disabled = false,
  className = '',
  ...props
}) => {
  return (
    <div className={`uc-form-check uc-form-switch ${styles.switchGroup} ${className}`}>
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={styles.input}
        {...props}
      />
      <label htmlFor={id} className={styles.label}>
        <span className={styles.switch}>
          <span className={styles.slider}></span>
        </span>
        {label}
      </label>
    </div>
  );
};

export default Switch;
